<template>
  <div class="teach-compre">
    <div class="tech-compre-title">
      <h1>项目的教学 全面、严谨且强悍</h1>
    </div>
    <div class="tech-compre-content">
      <img v-show="partNum === 0" src="../designImg/web2x_sheji ruanjian.png" alt="" />
      <img v-show="partNum === 1" src="../designImg/web2x_zupin.png" alt="" />
      <img v-show="partNum === 2" src="../designImg/web2x_changjing.png" alt="" />
      <div class="list-word">
        <div class="part-word" @mouseenter="showActive(0)" @mouseleave="showActive(0)" v-track="[ '设计软件全覆盖', '文字划过' ]">
          <div :class="{partWordHover: partNum === 0}" style="padding-top: 35px;">
            <h2>设计软件全覆盖</h2>
            <div class="part1">
              <p>
                <span class="first-span">20个主流设计软件</span>
                <span>领先设计教学领域</span>
              </p>
            </div>
            <div :class="{changeStyle: partNum === 0}"></div>
          </div>
        </div>
        <div class="part-word" @mouseenter="showActive(1)" @mouseleave="showActive(0)" v-track="[ '学员作品严把关', '文字划过' ]">
          <h2 style="margin-top: 35px;">学员作品严把关</h2>
          <div class="part2">
            <p>
              <span class="first-span">完整的学员作品和评审体系</span>
              <span>无雷同、严格化、一对一辅导，定义行业作品集标准</span>
            </p>
          </div>
          <div class="anam-hover"></div>
        </div>
        <div class="part-word" @mouseenter="showActive(2)" @mouseleave="showActive(0)" v-track="[ '场景式教学', '文字划过' ]">
          <h2 style="margin-top: 35px;">场景式教学</h2>
          <div class="part3">
            <p>
              <span class="first-span">引入真实企业环境，创设典型场景</span>
              <span>变单一封闭式教学为多元开放式教育</span>
            </p>
          </div>
          <div class="anam-hover"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      partNum: 0
    }
  },
  methods: {
    showActive (index) {
      this.partNum = index

    }
  }
}
</script>

<style lang="scss" scoped>
  .teach-compre {
    background-color: #fff;
    width: 100%;
    min-width: 1200px;
    height: auto;
    
    .tech-compre-title {
      margin: 0 auto;
      min-width: 1200px;
      padding-top: 76px;
      padding-bottom: 63px;
      h1 {
        font-size: 36px;
        // font-family: "Fontquan-qingkehuangyouti";
        font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Regular";
        font-weight: 400;
        text-align: center;
        color: #000000;
        line-height: 38px;
      }
    }
    .tech-compre-content {
      margin: 0 auto;
      width: 1200px;
      min-width: 1200px;
      overflow: hidden;
      padding-bottom: 72px;
      img {
        height: 420px;
        width: 100%;
        text-align: center;
        border: 0;
        transition: all 0.8s;
      }
      .list-word {
        width: 100%;
        height: 174px;
        display: flex;
        margin-top: -2px;
        .part-word {
          position: relative;
          animation: ad_width .5s linear forwards;
          cursor: pointer;
          width: 100%;
          height: 100%;
          flex: 1;
          background: #f2f3f5;
          h2 {
            width: 100%;
            height: 28px;
            padding-left: 38px;
            box-sizing: border-box;
            font-size: 20px;
            // font-family: Fontquan-qingkehuangyouti;
            font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Regular";
            font-weight: 600;
            color: #343434;
            line-height: 28px;
          }
          .partWordHover {
            width: 100%;
            height: 174px;
            background-color: #fff;
          }
          .changeStyle {
            display: block;
            width: 400px;
            height: 100%;
            border-bottom: 4px solid blue;
            position: absolute;
            bottom: 0;
            animation: ad_width .5s linear forwards;
          }
          .anam-hover {
            width: 400px;
            height: 4px;
            background-color: blue;
            position: absolute;
            bottom: 0;
            display: none;
            animation: ad_width .5s linear forwards;
          }
          @keyframes ad_width {
            from {
              width: 0
            }
            to {
              width: 400px
            }
          }
          .part1 {
            margin-left: 38px;
            width: 115px;
            height: 44px;
            font-size: 14px;
            // font-family: Fontquan-qingkehuangyouti;
            font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Regular";
            font-weight: 400;
            text-align: left;
            color: #5f6464;
            line-height: 20px;
            p {
              margin-top: 10px;
              .first-span {
                display: block;
                margin-top: 10px;
              }
              span {
                display: block;
                margin-top: 6px;
              }
            }
          }
          .part2 {
            margin-left: 38px;
            width: 322px;
            height: 44px;
            font-size: 14px;
            // font-family: Fontquan-qingkehuangyouti;
            font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Regular";
            font-weight: 400;
            text-align: left;
            color: #5f6464;
            line-height: 20px;
            p {
              margin-top: 10px;
              .first-span {
                display: block;
                margin-top: 10px;
              }
              span {
                display: block;
                margin-top: 6px;
              }
            }
          }
          .part3 {
            margin-left: 38px;
            width: 224px;
            height: 44px;
            font-size: 14px;
            // font-family: Fontquan-qingkehuangyouti;
            font-family: "MicrosoftYaHei", "PingFangSC", "PingFangSC-Regular";
            font-weight: 400;
            text-align: left;
            color: #5f6464;
            line-height: 20px;
            p {
              margin-top: 10px;
              .first-span {
                display: block;
                margin-top: 10px;
              }
              span {
                display: block;
                margin-top: 6px;
              }
            }
          }
        }
        .part-word:hover {
          background-color: #fff;
        }
        .part-word:hover .anam-hover {
          height: 4px;
          background-color: blue;
          position: absolute;
          bottom: 0;
          display: block;
          animation: ad_width .5s linear forwards;
        }
        
      }
    }
  }
</style>